import React from 'react';
import { BaseFirstNameInput } from 'src/components/enterprise/components/BaseFirstNameInput/BaseFirstNameInput';

export interface FirstNameControlProps {
  name: string;
  id: string;
}

export const FirstNameControl: React.FC<FirstNameControlProps> = ({
  name,
  id,
}) => {
  return (
    <BaseFirstNameInput
      name={name}
      id={id}
      rules={{
        required: 'First Name is required',
      }}
    />
  );
};
